import React, { useMemo, useState, useEffect } from 'react'
import { Input, Tabs, Checkbox, Pagination } from 'antd'
import TreeSelect from 'components/TreeSelect'
import AntdAvatar from 'components/Avatar'
import { StyledApprovalTable } from './style'
import ApprovedIcon from 'components/icons/TPORequestsIcons/ApprovedIcon'
import DeclinedIcon from 'components/icons/TPORequestsIcons/DeclinedIcon'
import FilterIcon from 'components/icons/FilterIcon'
import SearchIcon from 'components/icons/SearchIcon'
import ApprovalDrawer from './ApprovalDrawer'
import LeftArrow from 'components/icons/LeftArrow.js'
import { getProfileApprovalListing, getYearOfPassingFilter, getDegreeHierarchyFilter } from 'modules/TPOApproval/actions'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { COLORS } from 'theme'
import FilterDiv from '../FilterDiv/index.js'
import {
  StyledTab,
  SubmitFlex,
  MenuFlex,
} from 'modules/Students/Partials/StudentsInfoTable/Style/style'
import Button from 'components/Button'
import Select from 'components/Select'
import {
  Wrapper,
  Card,
  Title,
  Subtitle,
  Divider,
  BulkRow,
  TableHeaderRow,
  HeaderCell,
  ShowingText,
} from './style'


export default function ApprovalListing() {
  const navigate = useNavigate()
  const [search, setSearch] = useState('')
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [drawerOpen, setDrawerOpen] = useState(false)
  const [activeRecord, setActiveRecord] = useState(null)
  const [students, setStudents] = useState([])
  const [pagination, setPagination] = useState(null)
  const [loading, setLoading] = useState(false)
  const [sortQuery, setSortQuery] = useState('')
  const [refreshKey, setRefreshKey] = useState(0)
  const [isFilterOpen, setIsFilterOpen] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const pageSize = 10
  const [yearOfPassing, setYearOfPassing] = useState([])
  const [yearOptions, setYearOptions] = useState([])
  const [degreeHierarchy, setDegreeHierarchy] = useState([])
  const [selectedDegree, setSelectedDegree] = useState([])
  const [selectedDepartment, setSelectedDepartment] = useState([])
  const [selectedSpecialisation, setSelectedSpecialisation] = useState([])
  const [degreeTreeData, setDegreeTreeData] = useState([])
  const [departmentTreeData, setDepartmentTreeData] = useState([])
  const [specialisationTreeData, setSpecialisationTreeData] = useState([])
  const instituteCampusId = useSelector(
    state => state.auth?.instituteDetails?.id
  )
  const dispatch = useDispatch()
  const filtered = useMemo(() => {
    return students
      .map(s => ({
        key: s.studentId,
        name: s.studentName,
        roll: s.uniRollNo,
        phone: s.phoneNumber,
        email: s.email,
        degree: `${s.degree}${s.department ? ' - ' + s.department : ''}${s.specialization ? ' - ' + s.specialization : ''}`,
        changes: s.noOfChanges,
        files: s.noOfFilesUploaded,
        waiting: s.waitingTime,
        oldestRequestDate: s.oldestRequestDate,
        profileUrl: s.profileUrl,
      }))
  }, [students])

  useEffect(() => {
    if (!instituteCampusId) return

    const fetchFilterOptions = async () => {
      const [yearRes, degreeRes] = await Promise.all([
        dispatch(getYearOfPassingFilter(instituteCampusId)),
        dispatch(getDegreeHierarchyFilter(instituteCampusId))
      ])
      
      if (yearRes?.yearOfPassing) {
        setYearOptions(yearRes.yearOfPassing)
      }
      
      if (degreeRes?.degreeHierarchy) {
        setDegreeHierarchy(degreeRes.degreeHierarchy)
      }
    }

    fetchFilterOptions()
  }, [dispatch, instituteCampusId])

  const selectAllStructure = [{ title: 'Select All', value: 'all', children: [] }]

  useEffect(() => {
    if (degreeHierarchy.length > 0) {
      const degreeData = degreeHierarchy.map(degree => ({
        title: degree.degree,
        value: degree.degreeId,
      }))
      setDegreeTreeData(selectAllStructure.map(item => ({ ...item, children: degreeData })))
    }
  }, [degreeHierarchy])

  useEffect(() => {
    if (selectedDegree.length > 0 && degreeHierarchy.length > 0) {
      const deptData = degreeHierarchy
        .filter(degree => selectedDegree.includes(degree.degreeId))
        .map(degree => ({
          title: degree.degree,
          value: degree.degreeId,
          text: 'degree',
          children: degree.departments.map(dept => ({
            title: dept.department,
            value: `${degree.degreeId} ${dept.streamId}`,
            degreeId: degree.degreeId,
            streamId: dept.streamId,
            text: 'dept',
          }))
        }))
      setDepartmentTreeData(selectAllStructure.map(item => ({ ...item, children: deptData })))
    } else {
      setDepartmentTreeData([])
      setSelectedDepartment([])
    }
  }, [selectedDegree, degreeHierarchy])

  useEffect(() => {
    if (selectedDepartment.length > 0 && degreeHierarchy.length > 0) {
      const selectedStreamIds = selectedDepartment.map(item => {
        const parts = item.split(' ')
        return { degreeId: parts[0], streamId: parts[1] }
      })
      
      const specData = degreeHierarchy
        .filter(degree => selectedDegree.includes(degree.degreeId))
        .map(degree => ({
          title: degree.degree,
          value: degree.degreeId,
          text: 'degree',
          children: degree.departments
            .filter(dept => selectedStreamIds.some(s => s.degreeId === degree.degreeId && s.streamId === dept.streamId))
            .map(dept => ({
              title: dept.department,
              value: `${degree.degreeId} ${dept.streamId}`,
              text: 'dept',
              children: dept.specialisations.map(spec => ({
                title: spec.specialisation,
                value: `${degree.degreeId} ${dept.streamId} ${spec.specialisationId}`,
                degreeId: degree.degreeId,
                streamId: dept.streamId,
                specialisationId: spec.specialisationId,
                text: 'spec',
              }))
            }))
        }))
      setSpecialisationTreeData(selectAllStructure.map(item => ({ ...item, children: specData })))
    } else {
      setSpecialisationTreeData([])
      setSelectedSpecialisation([])
    }
  }, [selectedDepartment, selectedDegree, degreeHierarchy])

  const handleDegreeChange = (value) => {
    setSelectedDegree(value)
    setSelectedDepartment([])
    setSelectedSpecialisation([])
  }

  const handleDepartmentChange = (value) => {
    setSelectedDepartment(value)
    setSelectedSpecialisation([])
  }

  const handleSpecialisationChange = (value) => {
    setSelectedSpecialisation(value)
  }

  const buildCoursesPayload = () => {
    const courses = []
    
    if (selectedSpecialisation.length > 0) {
      selectedSpecialisation.forEach(item => {
        const parts = item.split(' ')
        if (parts.length === 3) {
          courses.push({ degreeId: parts[0], streamId: parts[1], specialisationId: parts[2] })
        }
      })
    } else if (selectedDepartment.length > 0) {
      selectedDepartment.forEach(item => {
        const parts = item.split(' ')
        if (parts.length === 2) {
          courses.push({ degreeId: parts[0], streamId: parts[1] })
        }
      })
    } else if (selectedDegree.length > 0) {
      selectedDegree.forEach(degreeId => {
        const degree = degreeHierarchy.find(d => d.degreeId === degreeId)
        if (degree) {
          degree.departments.forEach(dept => {
            courses.push({ degreeId, streamId: dept.streamId })
          })
        }
      })
    }
    
    return courses
  }

  useEffect(() => {
    if (!instituteCampusId) return

    const fetchListing = async () => {
      setLoading(true)
      const [sortField, sortOrder] = sortQuery.split(':')
      const yearOfPassingString = yearOfPassing.length > 0 ? yearOfPassing.join(',') : null
      const courses = buildCoursesPayload()
      const res = await dispatch(getProfileApprovalListing(instituteCampusId, search, sortField, sortOrder, currentPage, pageSize, yearOfPassingString, courses))

      if (res) {
        setStudents(res.students || [])
        setPagination(res.pagination || null)
      }

      setLoading(false)
    }

    fetchListing()
  }, [dispatch, instituteCampusId, search, sortQuery, refreshKey, currentPage, pageSize])

  const sortFieldMap = {
    changes: 'noOfChanges',
    files: 'noOfFilesUploaded',
    waiting: 'waitingTime'
  }

  const handleTableChange = (paginationConfig, filters, sorter) => {
    if (sorter?.field && sorter?.order) {
      const order = sorter.order === 'ascend' ? 'asc' : 'desc'
      const apiField = sortFieldMap[sorter.field] || sorter.field
      setSortQuery(`${apiField}:${order}`)
      setCurrentPage(1)
    } else if (sorter?.field === undefined) {
      setSortQuery('')
      setCurrentPage(1)
    }
  }

  const handlePageChange = (page) => {
    setCurrentPage(page)
  }

  const columns = [

    {
      title: 'Student Name',
      render: r => (
        <div style={{ display: 'flex', gap: 10 }}>
          <AntdAvatar
            style={{ verticalAlign: 'middle' }}
            src={r.profileUrl}
            IconName={r.name?.split('')[0]}
            size={35}
          />
          <div>
            <div 
              style={{ color: '#3249d7', fontWeight: 500, cursor: 'pointer' }}
              onClick={() => navigate(`/tpoApproval/student-resume/${r.key}`)}
            >
              {r.name}
            </div>
            <div style={{ fontSize: 12, color: '#999' }}>{r.roll}</div>
          </div>
        </div>
      ),
    },
    {
      title: 'Contact Details',
      render: r => (
        <div>
          <div>{r.phone}</div>
          <div style={{ fontSize: 12, color: '#999' }}>{r.email}</div>
        </div>
      ),
    },
    {
      title: 'Degree & Department',
      dataIndex: 'degree',
    },
    {
      title: 'No. of Changes',
      dataIndex: 'changes',
      align: 'center',
      sorter: true,
      render: (v, record) => <span style={{ color: '#3249d7', fontWeight: 500, cursor: 'pointer' }} onClick={
        e => {
          e.stopPropagation()
          setActiveRecord(record)
          setDrawerOpen(true)
        }
      }>{v}</span>,
    },
    {
      title: 'No. of Files Uploaded',
      dataIndex: 'files',
      align: 'center',
      sorter: true,
      render: (v, record) => v !== 0 ? <span style={{ color: '#3249d7', fontWeight: 500, cursor: 'pointer' }} onClick={
        e => {
          e.stopPropagation()
          setActiveRecord(record)
          setDrawerOpen(true)
        }
      }>{v}</span> : <span style={{ color: '#999' }}>0</span>
    },
    {
      title: 'Waiting Time',
      dataIndex: 'waiting',
      align: 'center',
      sorter: true,
      render: (v, record) => (
        <div>
          <div style={{ fontWeight: 500 }}>{v}</div>
          {record.oldestRequestDate && (
            <div style={{ fontSize: 12, color: '#999' }}>
              ({new Date(record.oldestRequestDate).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })})
            </div>
          )}
        </div>
      ),
    },
  ]
const RightPanelRow = ({ label, children }) => (
  <div
    style={{
      display: 'grid',
      gridTemplateColumns: '60px 1fr',
      alignItems: 'center',
      gap: 12,
    }}
  >
    <div style={{ fontSize: 13, color: '#333' }}>{label}</div>
    {children}
  </div>
)

  const filterMenu = (
  <MenuFlex column >
    <StyledTab tabPosition="left">

      <Tabs.TabPane tab="Degree & Department" key="1">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16,   padding: '20px 15px',
    maxWidth: 520,}}>
          <div>
            {/* <div style={{ marginBottom: 4, fontSize: 12, color: '#666' }}>Degree</div> */}
            <RightPanelRow label="Degree">
            <TreeSelect
              showArrow
              treeData={degreeTreeData}
              treeCheckable={true}
              placeholder="Select Degree"
              maxTagCount={1}
              maxTagPlaceholder={omittedValues => (
                <span><strong>{omittedValues?.length}+</strong> selected</span>
              )}
              onChange={handleDegreeChange}
              treeDefaultExpandAll={true}
              value={selectedDegree}
              listHeight={180}
              style={{ width: '100%' }}
            />
            </RightPanelRow>
          </div>
          <div>
            {/* <div style={{ marginBottom: 4, fontSize: 12, color: '#666' }}>Department</div> */}
            <RightPanelRow label="Depart.">
            <TreeSelect
              showArrow
              treeData={departmentTreeData}
              treeCheckable={true}
              placeholder="Select Department"
              maxTagCount={1}
              maxTagPlaceholder={omittedValues => (
                <span><strong>{omittedValues?.length}+</strong> selected</span>
              )}
              onChange={handleDepartmentChange}
              treeDefaultExpandAll={true}
              disabled={selectedDegree.length === 0}
              value={selectedDepartment}
              listHeight={180}
              style={{ width: '100%' }}
            />
            </RightPanelRow>
          </div>
          <div>
            {/* <div style={{ marginBottom: 4, fontSize: 12, color: '#666' }}>Specialisation</div> */}
            <RightPanelRow label="Spec.">
            <TreeSelect
              showArrow
              treeData={specialisationTreeData}
              treeCheckable={true}
              placeholder="Select Specialisation"
              maxTagCount={1}
              maxTagPlaceholder={omittedValues => (
                <span><strong>{omittedValues?.length}+</strong> selected</span>
              )}
              onChange={handleSpecialisationChange}
              treeDefaultExpandAll={true}
              disabled={selectedDepartment.length === 0}
              value={selectedSpecialisation}
              listHeight={180}
              style={{ width: '100%' }}
            />
            </RightPanelRow>
          </div>
        </div>
      </Tabs.TabPane>

      <Tabs.TabPane tab="Year Of Passing" key="2">
        <div style={{ padding: '10px' }}>
          <Select 
            mode="multiple"
            placeholder="Select Year Of Passing" 
            value={yearOfPassing}
            onChange={setYearOfPassing}
            allowClear
            style={{ width: '100%' }}
            options={yearOptions.map(year => ({ label: year, value: year }))}
          />
        </div>
      </Tabs.TabPane>

    </StyledTab>

    <SubmitFlex right>
      <Button.Secondary
        text="Cancel"
        onClick={() => {
          setYearOfPassing([])
          setSelectedDegree([])
          setSelectedDepartment([])
          setSelectedSpecialisation([])
          setIsFilterOpen(false)
        }}
      />
      <Button.Primary
        text="Apply Filter"
        onClick={() => {
          setCurrentPage(1)
          setRefreshKey(prev => prev + 1)
          setIsFilterOpen(false)
        }}
      />
    </SubmitFlex>
  </MenuFlex>
)

  return (
    <Wrapper>
      <Card>

        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div
            onClick={() => navigate('/tpoApproval')}
            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
          >
            <LeftArrow />
          </div>

          <Title>Profile Approval Listing</Title>
        </div>
        <Subtitle>
          Review all student-submitted profile updates in one place. Track pending
          changes, see how long they’ve been waiting, and prioritize approvals
          efficiently.
        </Subtitle>

        <Divider />

        <TableHeaderRow>
          <HeaderCell>
            <Input
              prefix={<SearchIcon />}
              placeholder="Search by keyword"
              value={search}
              onChange={e => {
                setSearch(e.target.value)
                setCurrentPage(1)
              }}
              bordered={false}
            />
          </HeaderCell>

<HeaderCell>
  <FilterDiv
    overlayMenu={filterMenu}
    open={isFilterOpen}
    setOpen={setIsFilterOpen}
    DWidth={'600px'}
  />
</HeaderCell>

          <HeaderCell>
            <ShowingText>
              Showing {Math.min(currentPage * pageSize, pagination?.total || 0)} of {pagination?.total || 0}
            </ShowingText>
          </HeaderCell>
        </TableHeaderRow>

        <StyledApprovalTable
          loading={loading}
          columns={columns}
          dataSource={filtered}
          pagination={false}
          onChange={handleTableChange}
        />
        {pagination?.total > 0 && (
          <div style={{ marginTop: 20, display: 'flex', justifyContent: 'center' }}>
            <Pagination
              current={currentPage}
              pageSize={pageSize}
              total={pagination?.total || 0}
              onChange={handlePageChange}
              showSizeChanger={false}
            />
          </div>
        )}
        <ApprovalDrawer
          open={drawerOpen}
          loading={loading}
          record={activeRecord}
          onRefresh={() => setRefreshKey(prev => prev + 1)}
          onClose={() => {
            setDrawerOpen(false)
            setActiveRecord(null)
          }}
        />
      </Card>
    </Wrapper>
  )
}
